import { useQuery } from '@apollo/client';
import { GetMarketplaceHome } from '@atlassian/mpac-services-client';
import { useMemo } from 'react';
export function useHomepage() {
  var _enterpriseData$marke, _enterpriseData$marke2, _sectionsAppsData$mar;
  let {
    productId,
    shouldFetchEnterpriseApps = true
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    data: enterpriseData,
    loading: enterpriseLoading,
    error: enterpriseError
  } = useQuery(GetMarketplaceHome, {
    variables: {
      productId,
      first: 1
    },
    skip: !shouldFetchEnterpriseApps
  });
  const {
    data: sectionsAppsData,
    loading: sectionsLoading,
    error: sectionsError
  } = useQuery(GetMarketplaceHome, {
    variables: {
      productId,
      after: 1
    }
  });
  const enterpriseAppsSectionData = enterpriseData === null || enterpriseData === void 0 ? void 0 : (_enterpriseData$marke = enterpriseData.marketplaceHome) === null || _enterpriseData$marke === void 0 ? void 0 : (_enterpriseData$marke2 = _enterpriseData$marke.sections) === null || _enterpriseData$marke2 === void 0 ? void 0 : _enterpriseData$marke2[0];
  let sponsoredData;
  let sectionsData;
  if (Array.isArray(sectionsAppsData === null || sectionsAppsData === void 0 ? void 0 : (_sectionsAppsData$mar = sectionsAppsData.marketplaceHome) === null || _sectionsAppsData$mar === void 0 ? void 0 : _sectionsAppsData$mar.sections)) {
    sponsoredData = sectionsAppsData.marketplaceHome.sections.find(_ref => {
      let {
        id
      } = _ref;
      return id === 'sponsored-listing__home';
    });
    sectionsData = sectionsAppsData.marketplaceHome.sections.filter(_ref2 => {
      let {
        id
      } = _ref2;
      return id !== 'sponsored-listing__home';
    });
  }
  return useMemo(() => ({
    enterpriseAppsSectionData,
    enterpriseAppsSectionDataError: enterpriseError,
    isEnterpriseAppsSectionLoadError: Boolean(enterpriseError),
    isEnterpriseAppsSectionLoading: enterpriseLoading,
    sponsoredData,
    sectionsData,
    sectionsDataError: sectionsError,
    isSectionsLoadError: Boolean(sectionsError),
    areSectionsLoading: sectionsLoading
  }), [enterpriseAppsSectionData, enterpriseError, enterpriseLoading, sponsoredData, sectionsData, sectionsError, sectionsLoading]);
}